import { Inject } from '@odinjs/odin';

import { HpmsTextHtmlAPI } from '@philips-emr/hpms-components/lib/components/hpms-text-html/hpms-text-html-api';
import { ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnCancel, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, ModalService } from '@philips-emr/tws-core/lib/services';

import { AssingTermAliases, FragmentNames, RootRoutes } from '../codegen';
import { Endpoints } from '../definitions/endpoints';
import TermsService from '../services/terms-service';

import BaseController from './base/base-controller';

interface Term {
  dsTerm: string,
  nrSequence: number,
}

@Controller({ fragment: FragmentNames.ASSING_TERM })
class AssingTermController extends BaseController {
  @Inject(AssingTermAliases.HPMS_TEXT_HTML_0)
  private textHtml: HpmsTextHtmlAPI;
  @Inject(AssingTermAliases.TOAST_NOTIFICATION)
  private toast: ToastNotificationAPI;

  @OnAfterFetch(AssingTermAliases.FETCH_0)
  onMountTermoTexto(event: FetchEvent): void {
    const { dsTerm } = event.data as Term;
    this.textHtml.setData(dsTerm);
  }

  @OnSubmit(AssingTermAliases.FORM_TERM)
  onSubmitTerm(event: SubmitEvent): void {
    const { record } = event;
    if (!record || !record.checked) {
      this.toast.setVisible(true);
      this.scrollDownPanelTerm();
      return;
    }

    void HttpService.post(Endpoints.POST.TERMS, {}, { body: record }).then(() => {
      ModalService.close('term-modal');
      TermsService.checkTerms();
    });
  }

  @OnCancel(AssingTermAliases.FORM_TERM)
  onclose(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(RootRoutes.ROUTE_LOGIN);
    });
  }

  scrollDownPanelTerm(): void {
    const termPanel = document.querySelector<HTMLDivElement>('.c-modal__content--with-stack-manager');
    if (termPanel) {
      const { scrollHeight } = termPanel;
      termPanel.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }
}

export default AssingTermController;
